export const constants = {
  loadingContent: 'Loading...',
  pageTitle: 'My Assets',
  newEntityBtnLabel: 'New Entity',
  noEntitiesFoundLabel: 'No Entities Found',
  allowedKinds: ['System', 'Component', 'API', 'Resource', 'Group'],
};
